
import { Component, OnInit, SkipSelf } from '@angular/core';
import { InvoicesService } from 'apis/ewallet';
import { ValuesService } from '../services/values.service';
import { MyInvoicesService } from '../services/my-invoices.service';

@Component({
  selector: 'app-invoices-list',
  templateUrl: './invoices-list.page.html',
  styleUrls: ['./invoices-list.page.scss'],
})
export class InvoicesListPage implements OnInit {



  constructor(public myInvoicesService: MyInvoicesService,
              private valuesService: ValuesService,
              private invoicesService: InvoicesService) {}

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.myInvoicesService.getInvoices();
  }

}



